import React from 'react';
import clsx from 'clsx';

import { useHistory, useParams } from 'react-router-dom';

// import Checkbox from '@material-ui/core/Checkbox';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/Delete';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import PeopleIcon from '@material-ui/icons/People';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import Input from '@material-ui/core/Input';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { PAGE_ROUTE } from '../../../constants';
import API from '../../../services/api';

import { getItemValue } from '../../helpers';
import CustomAlert from '../../custom/alert';
import CustomPaper from '../../custom/paper';
import CustomSelect from '../../custom/select';
import Title from '../../title';
import Subtitle from '../../subtitle';

import useStyles from './styles';
import { FormHelperText } from '@material-ui/core';

UserForm.defaultProps = {
  required: true,
  classes: [],
  schools: [],
  serie_title: 'Selecione uma série',
  series: [],
  email: '',
  name: '',
  password: '',
  placa: '',
  profile_id: null,
  school_ids: [],
  serie_ids: [],
  classe_ids: [],
};

export default function UserForm({ children, ...props }) {
  const { id } = useParams();

  const defaultClasse = {
    id: 0,
    name: '',
    serie: {
      id: 0,
      name: '',
      school: {
        id: 0,
        name: '',
      },
    },
  };

  const defaultOptions = {
    schools: [],
    series: [],
    classes: [],
  };

  const load = React.useRef(true);

  const history = useHistory();
  const styles = useStyles();
  const [classe, setClasse] = React.useState(defaultClasse);
  const [alert, setAlert] = React.useState({ open: false, message: '' });

  const [options, setOptions] = React.useState(defaultOptions);
  const [state, setState] = React.useState(UserForm.defaultProps);
  const [title, setTitle] = React.useState('');
  const [validate, setValidate] = React.useState({});
  const [visible, setVisible] = React.useState(false);

  const [classes, setClasses] = React.useState([
    // { school_name: 'Escola 1', serie_name: '4 ano', classe_name: 'A' },
    // { school_name: 'Escola 2', serie_name: '5 ano', classe_name: 'A' },
    // { school_name: 'Escola 2', serie_name: '5 ano', classe_name: 'B' },
    // { school_name: 'Escola 4', serie_name: '5 ano', classe_name: 'A' },
    // { school_name: 'Escola 5', serie_name: '6 ano', classe_name: 'A' },
  ]);

  function componentDidMount() {
    if (load.current) {
      API.Schools.index().then(onSuccessSchool).catch(onFailure);
      if (id) {
        setTitle('Atualizar cliente');

        function onSuccessState(response) {
          if (load.current && response.data) {
            setState({ ...response.data });
            // setState(state => response.data);
            if (Array.isArray(response.data.classe)) {
              setClasses(response.data.classe);
            }
          }
          setVisible(true);
        }
        API.Users.show(id).then(onSuccessState).catch(onFailure);
      } else {
        setVisible(true);
        setTitle('Adicionar cliente');
      }
    }
    return function componentWillUnmount() {
      load.current = false;
    };
  }

  React.useEffect(componentDidMount, []);

  /*
  React.useEffect(() => {
    if (id) {
      setTitle('Atualizar cliente');
      function onSuccess(response) {
        if (load.current) {
          return;
        }
        if (response.data) {
          setState({ ...response.data });
          // setState(state => response.data);
        }
        setVisible(true);
      }
      function onFailure(error) {
        console.log(error.toString());
      }
      API.Users.show(id).then(onSuccess).catch(onFailure);
      return () => {
        load.current = true;
      };
    }
    else {
      setVisible(true);
      setTitle('Adicionar cliente');
      return;
    }
  }, [id]);
*/

  function onValueChanged() {
    console.log('classe Changed =>', classe);
    console.log('options Changed =>', options);
  }

  // function onStateChanged() {
  //   console.log('onStateChanged =>', state);
  // }

  React.useEffect(onValueChanged, [classe]);
  // React.useEffect(onStateChanged, [state]);

  function handleBackClick(event) {
    event.preventDefault();
    history.goBack();
  }

  function validateEmail(email) {
    // return true;
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
  }

  function handleSubmit(event) {
    event.preventDefault();

    if (!state.name) {
      setValidate({ ...validate, name: 'Por favor, preencha o nome do cliente' });
      return;
    }

    if (!state.email) {
      setValidate({ ...validate, email: 'Por favor, preencha o email do cliente' });
      return;
    }

    if (!validateEmail(state.email)) {
      setValidate({ ...validate, email: 'Por favor, utilize um email válido' });
      return;
    }

    if (!state.profile_id) {
      setValidate({ ...validate, profile_id: 'Por favor, selecione um perfil' });
      return;
    }

    if ((state.profile_id === 2 || state.profile_id === 3) && Array.isArray(classes) && classes.length < 1) {
      setAlert({ open: true, message: 'Você precisa adicionar pelo menos uma turma.' });
      return;
    }

    function onSuccess() {
      history.push(PAGE_ROUTE.USERS);
    }

    const classe_ids = [];

    for (const classe of classes) {
      classe_ids.push(parseInt(classe.id));
    }

    const user = { ...state, classe_ids: classe_ids };

    if (id) {
      API.Users.update(id, user).then(onSuccess).catch(onFailure);
    } else {
      API.Users.store(user).then(onSuccess).catch(onFailure);
    }
  }

  function handleKeyDown(event) {
    // Esc = 27
    if (event.which === 27) {
      handleBackClick(event);
    }
    // Enter = 13
    else if (event.which === 13) {
      event.preventDefault();
      handleSubmit(event);
    }
  }

  // const handleChangeCheckBoxIsAdmin = (event) => {
  //   setState({ ...state, [event.target.name]: event.target.checked, school_id: null, serie_id: null });
  // };

  const handleChangeSelectProfile = (event) => {
    setState({ ...state, profile_id: event.target.value, school_id: null, serie_id: null });
    setClasse(defaultClasse);
    setClasses([]);
  };

  function handleOnChangeSchool(event, selected) {
    event.preventDefault();
    setClasse({
      serie: {
        school: {
          id: event.target.value,
          name: selected.props.children,
        },
      },
    });
    API.Series.index({ school_id: event.target.value }).then(onSuccessSerie).catch(onFailure);
  }

  function handleOnChangeSerie(event, selected) {
    event.preventDefault();
    setClasse({
      ...classe,
      serie: {
        id: event.target.value,
        name: selected.props.children,
        school: classe.serie.school,
      },
    });
    API.Classes.index({ serie_id: event.target.value }).then(onSuccessClasse).catch(onFailure);
  }

  function handleOnChangeClasse(event, selected) {
    event.preventDefault();
    setClasse({
      ...classe,
      id: event.target.value,
      name: selected.props.children,
    });
  }

  function mergeOptions(object) {
    if (load.current && object) {
      setOptions({
        ...options,
        ...object,
      });
    }
  }

  function onSuccessSchool(response) {
    mergeOptions({
      schools: response.data.data,
      series: [],
      classes: [],
    });
  }

  function onSuccessSerie(response) {
    mergeOptions({
      series: response.data.data,
      classes: [],
    });
  }

  function onSuccessClasse(response) {
    mergeOptions({
      classes: response.data.data,
    });
  }

  function onFailure(error) {
    if (load.current && error) {
      setAlert({ open: true, message: error.message });
    }
  }

  function validateClasse() {
    if (!getItemValue(classe, ['serie', 'school', 'id'], null)) {
      setValidate({ ...validate, school_id: 'Por favor, selecione uma escola' });
      return false;
    }
    if (!getItemValue(classe, ['serie', 'id'], null)) {
      setValidate({ ...validate, serie_id: 'Por favor, selecione uma série' });
      return false;
    }
    if (!getItemValue(classe, ['id'], null)) {
      setValidate({ ...validate, classe_id: 'Por favor, selecione uma turma' });
      return false;
    }
    return true;
  }

  function handleOnClick(event) {
    event.preventDefault();
    if (validateClasse()) {
      if (
        classes.find((item) => {
          return item.id === classe.id;
        })
      ) {
        setAlert({ open: true, message: 'Esta turma já foi adicionada.' });
      } else {
        setClasses([...classes, classe]);
        setClasse(defaultClasse);
        setOptions({ ...defaultOptions, schools: options.schools });
      }
    }
  }

  function handleOnRemoveClick(event, index) {
    event.preventDefault();
    setClasses(classes.filter((_, idx) => idx !== index));
  }

  const formatString = (string = '', trim = true, upper = true, lower = false, spaces = true) => {
    let value = String(string);
    if (trim === true) {
      value = value.trim();
    }
    if (spaces === false) {
      value = value.replace(/\s/g, '');
    }
    if (lower === true && upper === false) {
      value = value.toLowerCase();
    }
    if (upper === true && lower === false) {
      value = value.toUpperCase();
    }
    return value;
  };

  const handleChangeState =
    (trim = false, upper = false, lower = false, spaces = true) =>
    (event) => {
      setState({ ...state, [event.target.name]: formatString(event.target.value, trim, upper, lower, spaces) });
    };

  const handleClickShowPassword = () => {
    setState({ ...state, showPassword: !state.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <CustomPaper>
        <Grid container spacing={1}>
          <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
            {alert.message}
          </CustomAlert>
          <Grid item>
            <IconButton onClick={handleBackClick}>
              <ChevronLeftIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <Title>
              <PeopleIcon />
            </Title>
          </Grid>
          <Grid item>
            <Title>{title}</Title>
          </Grid>
        </Grid>

        {visible && (
          <>
            <Subtitle align="center">{'Informe os dados do cliente'}</Subtitle>

            <TextField
              id="input-name"
              name="name"
              label="Nome"
              className={styles.formControl}
              helperText={validate.name ? validate.name : ''}
              error={validate.name ? true : false}
              onFocus={(event) => setValidate({ ...validate, name: null })}
              required={true}
              value={state.name || ''}
              onKeyDown={handleKeyDown}
              onChange={handleChangeState(false, false, false)}
              onBlur={handleChangeState(true, false, false)}
              InputProps={{
                autoFocus: true,
              }}
            />

            <TextField
              id="input-email"
              name="email"
              label="Email"
              className={styles.formControl}
              helperText={validate.email ? validate.email : ''}
              error={validate.email ? true : false}
              onFocus={(event) => setValidate({ ...validate, email: null })}
              required={true}
              value={state.email || ''}
              onKeyDown={handleKeyDown}
              onChange={handleChangeState(true, false, true, false)}
              onBlur={handleChangeState(true, false, true, false)}
            />

            <FormControl className={clsx(styles.formControl)}>
              <InputLabel htmlFor="standard-adornment-password">{'Senha'}</InputLabel>
              <Input
                id="standard-adornment-password"
                name="password"
                type={state.showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                required={false}
                value={state.password}
                onChange={handleChangeState(false, false, false)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                      {state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            {/* <TextField
              className={styles.formControl}
              type='password'
              autoComplete='current-password'
              required={false}
              value={state.password || ''}
              label='Senha'
              onKeyDown={handleKeyDown}
              onChange={(event) => setState({ ...state, password: event.target.value })}
            /> */}

            {/*
          <FormControlLabel
            className={styles.formControl}
            control={<Checkbox checked={state.profile_id} onChange={handleChangeCheckBoxIsAdmin} name='profile_id' />}
            label='Conta de Administrador'
          />
          */}
            <CustomSelect
              title={'Perfil'}
              first={'Selecione um perfil'}
              value={state.profile_id || null}
              helperText={validate.profile_id ? validate.profile_id : ''}
              error={validate.profile_id ? true : false}
              onFocus={() => setValidate({ ...validate, profile_id: null })}
              onKeyDown={handleKeyDown}
              // onChange={(event) => setState({ ...state, profile_id: event.target.value })}
              onChange={handleChangeSelectProfile}
              fetch={API.Profiles.index}
            />
            {state.profile_id === 3 && (
              <TextField
                className={styles.formControl}
                required={false}
                value={state.placa || ''}
                label="Placa"
                onKeyDown={handleKeyDown}
                onChange={(event) => setState({ ...state, placa: event.target.value })}
                onBlur={(event) => setState({ ...state, placa: event.target.value.trim() })}
                type="number"
                InputProps={{
                  inputProps: {
                    min: 0,
                    max: 1000000,
                  },
                }}
              />
            )}

            {/*
          { // (state.profile_id === 2 || state.profile_id === 3) &&
          <CustomSelect
            title={'Agência'}
            first={'Selecione uma agência'}
            value={state.school_id || null}
            helperText={validate.school_id ? validate.school_id : ''}
            error={validate.school_id ? true : false}
            onFocus={() => setValidate({ ...validate, school_id: null })}
            onKeyDown={handleKeyDown}
            onChange={(event) => setState({ ...state, school_id: event.target.value })}
            fetch={API.Schools.index}
            filter={{ bank_id: 1 }}
          />
          }
          { // state.profile_id === 3 &&
          <CustomSelect
            title={'Série'}
            first={'Selecione uma série'}
            value={state.serie_id || null}
            helperText={validate.serie_id ? validate.serie_id : ''}
            error={validate.serie_id ? true : false}
            onFocus={() => setValidate({ ...validate, serie_id: null })}
            onKeyDown={handleKeyDown}
            onChange={(event) => setState({ ...state, serie_id: event.target.value })}
            fetch={API.Series.index}
            filter={state.school_id ? { school_id: state.school_id } : null}
            mount={false}
          />
          }
          */}
          </>
        )}
      </CustomPaper>
      {state.profile_id > 1 && (
        <>
          <CustomPaper>
            {state.profile_id === 2 && <Subtitle align="center">{'Adicione uma ou mais turmas'}</Subtitle>}
            {state.profile_id === 3 && Array.isArray(classes) && classes.length < 1 && <Subtitle align="center">{'Adicione uma turma'}</Subtitle>}
            {state.profile_id === 3 && Array.isArray(classes) && classes.length > 0 && (
              <Subtitle align="center">{'Turma selecionada (Você pode selecionar apenas uma turma para este perfil)'}</Subtitle>
            )}
            {(state.profile_id === 2 || (state.profile_id === 3 && Array.isArray(classes) && classes.length < 1)) && (
              <>
                <FormControl className={styles.formControl} error={validate.school_id ? true : false} onFocus={(event) => setValidate({ ...validate, school_id: null })} required={false}>
                  <InputLabel>{'Escola'}</InputLabel>
                  <Select onChange={handleOnChangeSchool} value={getItemValue(classe, ['serie', 'school', 'id'], 0)}>
                    <MenuItem value={0} disabled>
                      <em>{'Selecione uma escola'}</em>
                    </MenuItem>
                    {Array.isArray(options.schools) &&
                      options.schools.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                  {validate.school_id && <FormHelperText>{validate.school_id}</FormHelperText>}
                </FormControl>
                <FormControl className={styles.formControl} error={validate.serie_id ? true : false} onFocus={(event) => setValidate({ ...validate, serie_id: null })} required={false}>
                  <InputLabel>{'Série'}</InputLabel>
                  <Select autoWidth={true} onChange={handleOnChangeSerie} value={getItemValue(classe, ['serie', 'id'], 0)}>
                    <MenuItem value={0} disabled>
                      <em>{'Selecione uma série'}</em>
                    </MenuItem>
                    {Array.isArray(options.series) &&
                      options.series.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {validate.serie_id && <FormHelperText>{validate.serie_id}</FormHelperText>}
                </FormControl>
                <FormControl className={styles.formControl} error={validate.classe_id ? true : false} onFocus={(event) => setValidate({ ...validate, classe_id: null })} required={false}>
                  <InputLabel>{'Turma'}</InputLabel>
                  <Select autoWidth={true} onChange={handleOnChangeClasse} value={getItemValue(classe, ['id'], 0)}>
                    <MenuItem value={0} disabled>
                      <em>{'Selecione uma turma'}</em>
                    </MenuItem>
                    {Array.isArray(options.classes) &&
                      options.classes.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                  {validate.classe_id && <FormHelperText>{validate.classe_id}</FormHelperText>}
                </FormControl>
                <Button className={styles.formControl} variant="contained" color="primary" onClick={handleOnClick}>
                  {'ADICIONAR TURMA'}
                </Button>
              </>
            )}

            {Array.isArray(classes) && classes.length > 0 && (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{'Escola'}</TableCell>
                    <TableCell align="left">{'Série'}</TableCell>
                    <TableCell align="left">{'Turma'}</TableCell>
                    <TableCell align="center">{'Remover'}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {classes.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">{getItemValue(item, ['serie', 'school', 'name'], '')}</TableCell>
                      <TableCell align="left">{getItemValue(item, ['serie', 'name'], '')}</TableCell>
                      <TableCell align="left">{getItemValue(item, ['name'], '')}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={(e) => handleOnRemoveClick(e, index)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </CustomPaper>
        </>
      )}

      <CustomPaper>
        <Subtitle align="center">{'Verifique as informações acima e confirme'}</Subtitle>
        <Button className={styles.button} type="submit" variant="contained" color="primary" fullWidth={false} onKeyDown={handleKeyDown} onClick={handleSubmit}>
          {id ? 'ATUALIZAR CLIENTE' : 'ADICIONAR CLIENTE'}
        </Button>
      </CustomPaper>
    </>
  );
}
